import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import {
    Modal,
    ModalComponent,
    ModalProps,
} from '@speeki/global-ui-components';

import { useServiceRedirect } from '@utils/hooks/useServiceRedirect';

import { getPath } from '@services/RouteService/paths';

import {
    AuthLink,
    LinkWrapper,
    RedirectWrapper,
    SignUpButton,
} from './GuestInfoModal.styled';

interface GuestInfoModalProps extends Pick<ModalProps, 'onClose' | 'open'> {}

export const GuestInfoModal = ({ onClose, open }: GuestInfoModalProps) => {
    useServiceRedirect({ path: '/disclosure/list' });

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { search } = useLocation();

    const onPress = () => {
        onClose();
        navigate(getPath({ path: '/auth/signup' }) + search);
    };

    return (
        <ModalComponent closeButton onClose={onClose} open={open} width={648}>
            <Modal.Content variant="secondary">
                <Modal.Header>
                    <Modal.TitleSecondary center>
                        {t('DISCLOSURE_GUEST_INFO_TITLE')}
                    </Modal.TitleSecondary>
                    <Modal.Description>
                        {t('DISCLOSURE_GUEST_INFO_DESCRIPTION')}
                    </Modal.Description>
                </Modal.Header>

                <RedirectWrapper>
                    <SignUpButton
                        onClick={onPress}
                        testId="tlATFcI"
                        variant={'primary'}
                    >
                        {t('CREATE_SPEEKI_ACCOUNT')}
                    </SignUpButton>
                    <LinkWrapper>
                        {t('ALREADY_HAVE_AN_ACCOUNT_TEXT')}{' '}
                        <AuthLink
                            onClick={onClose}
                            to={{
                                pathname: getPath({ path: '/auth/login' }),
                                search,
                            }}
                        >
                            {t('LOGIN')}
                        </AuthLink>
                    </LinkWrapper>
                </RedirectWrapper>
            </Modal.Content>
        </ModalComponent>
    );
};
